import {defineStore} from "pinia";
import axios from "axios";
import {BACKEND_BASEURL} from "@/config/config";
import DateUtil from "@/lib/es-bill-shared-js/util/DateUtil";

export class DataAnalysisResultMpAndDate {
  constructor(apiObject) {
    const {meteringPoint,date} = apiObject;

    this.meteringPoint = meteringPoint;
    this.date = new Date(date);
  }
}

export class DataAnalysisResultWrongQh {
  constructor(apiObject) {
    const {ecn, date, meterCode, meteringPoint, dateLastUpdate, qh, qhShould} = apiObject;


    this.ecn = ecn;
    this.date = new Date(date);
    this.meteringPoint = meteringPoint;
    this.meterCode = meterCode;
    this.dateLastUpdate = new Date(dateLastUpdate);
    this.qh = qh;
    this.qhShould = qhShould;

  }
}

export class DataAnalysisResulCompleteness {
  constructor(apiObject) {
    const {meteringPoint,date,meterCodesMissing,meterCodesSurplus} = apiObject;

    this.meteringPoint = meteringPoint;
    this.date = new Date(date);
    this.meterCodesMissing = meterCodesMissing;
    this.meterCodesSurplus = meterCodesSurplus;
  }
}

export class ConsumptionDataMeta {
  constructor(apiObject) {
    const {ecn, date, meterCode, meteringPoint, dateLastUpdate, sumEntry} = apiObject;


    this.ecn = ecn;
    this.date = new Date(date);
    this.meteringPoint = meteringPoint;
    this.meterCode = meterCode;
    this.dateLastUpdate = new Date(dateLastUpdate);

    this.sumEntry = {
      datestringStart: sumEntry.datestringStart,
      datestringTo: sumEntry.datestringTo,
      meteringMethod: sumEntry.meteringMethod,
      billingUOM: sumEntry.billingUOM,
      billingQuantity: sumEntry.billingQuantity,
    };
  }
}

/**
 * Contract store
 * Uniquely identifies contract by _id from MongoDB
 */
export const useDataAnalysisStore = defineStore('dataAnalysis', {
  state: () => ({}),

  actions: {

    async getUncleanMps(ecn, ecid, dateStart, dateEnd) {
      try {
        const urlParts = [
          "dataAnalysis",
          ecn,
          ecid,
          "uncleanMeteringPoints",
          "from",
          DateUtil.formatDateForEnergyDataService(dateStart),
          "to",
          DateUtil.formatDateForEnergyDataService(dateEnd),
        ]

        const response = await axios.get(BACKEND_BASEURL + urlParts.join('/'));

        return response.data.map(e => {
          return new DataAnalysisResultMpAndDate(e)
        });

      } catch (error) {
        console.error('Failed to fetch uncleanMeteringPoints:', error);
      }
    }, // getUncleanMps

    async getUncleanMpsForMeterCode(ecn, ecid, meterCode, dateStart, dateEnd) {
      try {
        const urlParts = [
          "dataAnalysis",
          ecn,
          ecid,
          "uncleanMeteringPointsMeterCode",
          meterCode,
          "from",
          DateUtil.formatDateForEnergyDataService(dateStart),
          "to",
          DateUtil.formatDateForEnergyDataService(dateEnd),
        ]

        const response = await axios.get(BACKEND_BASEURL + urlParts.join('/'));

        return response.data.map(e => {
          return new DataAnalysisResultMpAndDate(e)
        });

      } catch (error) {
        console.error('Failed to fetch uncleanMeteringPointsMeterCode:', error);
      }
    }, // getUncleanMpsForMeterCode

    async getUncleanDataEntriesForCommunity(ecn, ecid, dateStart, dateEnd) {
      try {
        const urlParts = [
          "dataAnalysis",
          ecn,
          ecid,
          "uncleanMeteringPointsDetail",
          "from",
          DateUtil.formatDateForEnergyDataService(dateStart),
          "to",
          DateUtil.formatDateForEnergyDataService(dateEnd),
        ]

        const response = await axios.get(BACKEND_BASEURL + urlParts.join('/'));

        return response.data.map(e => {
          return new ConsumptionDataMeta(e)
        });

      } catch (error) {
        console.error('Failed to fetch uncleanMeteringPointsDetail:', error);
      }
    }, // getUncleanDataEntriesForCommunity



    async uncleanMeteringPointsDetailMeterCode(ecn, ecid, meterCode, dateStart, dateEnd) {
      try {
        const urlParts = [
          "dataAnalysis",
          ecn,
          ecid,
          "getUncleanDataEntriesForCommunityForMeterCode",
          meterCode,
          "from",
          DateUtil.formatDateForEnergyDataService(dateStart),
          "to",
          DateUtil.formatDateForEnergyDataService(dateEnd),
        ]

        const response = await axios.get(BACKEND_BASEURL + urlParts.join('/'));

        return response.data.map(e => {
          return new ConsumptionDataMeta(e)
        });

      } catch (error) {
        console.error('Failed to fetch getUncleanDataEntriesForCommunityForMeterCode:', error);
      }
    }, // uncleanMeteringPointsDetailMeterCode


    async getIncorrectCountofQh(ecn, ecid, dateStart, dateEnd) {
      try {
        const urlParts = [
          "dataAnalysis",
          ecn,
          ecid,
          "incorrectCountofQh",
          "from",
          DateUtil.formatDateForEnergyDataService(dateStart),
          "to",
          DateUtil.formatDateForEnergyDataService(dateEnd),
        ]

        const response = await axios.get(BACKEND_BASEURL + urlParts.join('/'));

        return response.data.map(e => {
          return new DataAnalysisResultWrongQh(e)
        });

      } catch (error) {
        console.error('Failed to fetch getIncorrectCountofQh:', error);
      }
    }, // uncleanMeteringPointsDetailMeterCode


    async getIncorrectMeterCodes(ecn, ecid, dateStart, dateEnd) {
      try {
        const urlParts = [
          "dataAnalysis",
          ecn,
          ecid,
          "incorrectMeterCodes",
          "from",
          DateUtil.formatDateForEnergyDataService(dateStart),
          "to",
          DateUtil.formatDateForEnergyDataService(dateEnd),
        ]

        const response = await axios.get(BACKEND_BASEURL + urlParts.join('/'));

        return response.data.map(e => {
          return new DataAnalysisResulCompleteness(e)
        });

      } catch (error) {
        console.error('Failed to fetch getIncorrectMeterCodes:', error);
      }
    }, // uncleanMeteringPointsDetailMeterCode

  }
});
